import { component$ } from "@builder.io/qwik";
import { useDocumentHead, useLocation } from "@builder.io/qwik-city";
import { isDev } from "@builder.io/qwik/build";

/**
 * The RouterHead component is placed inside of the document `<head>` element.
 */
export const RouterHead = component$(() => {
  const head = useDocumentHead();
  const loc = useLocation();

  const canonicalUrl = new URL(loc.url.href);
  if (!isDev && import.meta.env.VITE_APP_HOST) {
    canonicalUrl.host = import.meta.env.VITE_APP_HOST;
  }

  return (
    <>
      <title>{head.title}</title>

      <link rel="canonical" href={canonicalUrl.href} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="icon" href="/favicon.ico" sizes="any" />
      <link rel="icon" href="/favicon.svg" type="image/svg+xml" />

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />

      {(() => {
        const renderedMetaKeys = new Set<string>();
        return head.meta
          .filter((m) => {
            if (m.key && renderedMetaKeys.has(m.key)) {
              return false;
            }
            if (m.key) {
              renderedMetaKeys.add(m.key);
            }
            return true;
          })
          .map((m) => <meta key={m.key} {...m} />);
      })()}

      {head.links.map((l) => (
        <link key={l.key} {...l} />
      ))}

      {head.styles.map((s) => (
        <style
          key={s.key}
          {...s.props}
          {...(s.props?.dangerouslySetInnerHTML
            ? {}
            : { dangerouslySetInnerHTML: s.style })}
        />
      ))}

      {head.scripts.map((s) => (
        <script
          key={s.key}
          {...s.props}
          {...(s.props?.dangerouslySetInnerHTML
            ? {}
            : { dangerouslySetInnerHTML: s.script })}
        />
      ))}
    </>
  );
});
